
import React, { useState } from 'react';
import { AutoComplete } from 'antd';
import { Switch } from 'antd';
import './index.css';

export const AutoCompleteBox = (props) => {
  const { options, setTableData } = props;
  const [isNameSwitch, setIsNameSwitch] = useState(true);

  const getCurrentOptions = () => options ? (isNameSwitch ? options.map(v => ({ value: v.decisionName }))
    : options.map(v => ({ value: v.decisionNumber }))) : [];

  const onSelect = selected => {
    const targetOption = options.filter(o => isNameSwitch ?
      o.decisionName === selected : o.decisionNumber === selected)[0];
    setTableData([{
      name: targetOption.decisionName,
      url: targetOption.decisionPdfUrl
    }])
  };

  const onSwitchChange = selected => setIsNameSwitch(selected);

  return (
    <div className="auto-container">
      <AutoComplete
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        className="auto-com"
        onSelect={onSelect}
        options={getCurrentOptions()}
        style={{width: 291}}
        placeholder= {isNameSwitch ?  'name' : 'number'} />

      <div className="auto-switch">
        <Switch checkedChildren="name" unCheckedChildren="number" onChange={onSwitchChange} size="small" defaultChecked />
      </div>
    </div>
  );
}
